import { NetworkPortfolioManagementProjectTypeEnum } from "@app/network-portfolio-management/interfaces";

export const isCountyAdequacyProject = (
  projectType: NetworkPortfolioManagementProjectTypeEnum | undefined,
): boolean =>
  projectType === NetworkPortfolioManagementProjectTypeEnum.CountyNetworkAssessment
  || projectType === NetworkPortfolioManagementProjectTypeEnum.Blended;

export const isAdequacyProject = (
  projectType: NetworkPortfolioManagementProjectTypeEnum | undefined,
): boolean =>
  isCountyAdequacyProject(projectType)
  || projectType === NetworkPortfolioManagementProjectTypeEnum.ZipCodeNetworkAssessment;

export const isAccuracyProject = (
  projectType: NetworkPortfolioManagementProjectTypeEnum | undefined,
): boolean =>
  projectType === NetworkPortfolioManagementProjectTypeEnum.Accuracy
  || projectType === NetworkPortfolioManagementProjectTypeEnum.Blended;

export const aliasLabel = (alias: string | null | undefined, fallback: string): string =>
  (alias && alias.trim()) || fallback;

/** Pluralizes the word "project" for user-facing counts: 1 → "project", otherwise "projects". */
export const projectNoun = (count: number): string => (count === 1 ? "project" : "projects");
